import { Trans, useTranslation } from "react-i18next";
import type { CurrentFolderHintProps } from "./types";

export const CurrentFolderHint = ({
  currentFolderName,
}: CurrentFolderHintProps) => {
  const { t } = useTranslation();

  if (currentFolderName === null) {
    return (
      <p className="text-xs text-gray-500">
        {t("smartSurveyor.folders.currentFolderNoneHint")}
      </p>
    );
  }

  // Names are escaped before the <b> markup is parsed, so a "<" in a folder name stays text.
  return (
    <p className="text-xs text-gray-500">
      <Trans
        i18nKey="smartSurveyor.folders.currentFolderHint"
        values={{
          name: currentFolderName,
          noFolder: t("smartSurveyor.folders.noFolder"),
        }}
        components={{ b: <span className="font-medium text-gray-700" /> }}
        tOptions={{ interpolation: { escapeValue: true } }}
        shouldUnescape
      />
    </p>
  );
};
